import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Component/Sidebar';
import { UserContex } from '../context API/UserContext';

const Setting = ({logout}) => {
   const [userData, setUserData] = useContext(UserContex);
   const navigate = useNavigate();
  useEffect(() => {
    if (!userData.user) {
      navigate("/login");
    }
  });
  return (
    <div className="flex ">
      <Sidebar logout={logout} />
      Setting
    </div>
  );
}

export default Setting
